function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZorro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.745,
    height: 296.241,
    viewBox: "0 0 62.639 78.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M401.599 612.866c-7.944 14.134-18.317 16.978-34.038 24.084-21.39 9.671-34.954 33.403-28.73 56.76l14.353 6.279c31.922-16.154 59.568-49.504 48.415-87.123",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.204 655.931c6.033-13.057 7.949-27.704 3.395-43.065-7.352 13.079-16.786 16.492-30.61 22.56 6.652 9.584 16.287 16.296 27.215 20.505",
    style: {
      fill: "#ffd98b"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.004 678.989-15 50c17.73 1.098 41.416-19.79 46.797-35.777 8.002-23.773-18.664-31.223-31.797-14.223",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.672 705.986c11.988-.663 32.683 12.439 16.219 21.571-12.496 6.932-29.296-2.954-40.219-8.239z",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.004 673.989c-9.048-7.528-22.675-14.026-33.023-5.023-8.688 7.559-8.972 23.136-3.751 32.242 9.453 16.489 30.82 23.465 46.774 28.781z",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.004 706.986c-11.989-.663-32.683 12.439-16.219 21.571 12.496 6.932 29.296-2.954 40.219-8.239z",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.004 620.989c-21.328.711-19.838-13.701-34.223 24.223-9.777 25.777-18.507 54.453-7.777 75.777 7.917 15.732 70.976 13.704 84 2 15.752-14.173-12-103-42-102",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.243 626.989c-.029.001-27.142 1-27.142 1.003 1.053 21.005-22.518 70.708-2.639 87.566 11.121 9.431 31.49 10.485 40.426-5.18 7.869-13.795-11.83-83.33-10.645-83.389",
    style: {
      fill: "#ffd98b"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.713 500.631c-2.899 1.512-5.26 4.416-6.736 9.137-3.374 10.795 1.9 41.938 16.671 42.417 11.67-5.305 36.637-10.471 29.883-27.176-4.577-11.324-27.254-30.929-39.818-24.378",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.155 534.84q.031.596.135 1.183c.037-.358-.016-.768-.135-1.183",
    style: {
      fill: "#ffd98b"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.544 508.032c-7.45 5.865-5.508 19.11-1.755 26.444 1.797 3.511 5.066 8.845 9.405 9.69 8.356 1.627 4.96-5.575 6.829-10.852 12.706-1.661 8.354-11.752 3.137-17.82-3.769-4.386-11.397-12.358-17.616-7.462",
    style: {
      fill: "#ffd98b"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.505 502.436c2.899 1.512 5.261 4.416 6.736 9.137 3.374 10.795-1.9 41.938-16.672 42.417-11.67-5.304-36.637-10.471-29.883-27.176 4.58-11.325 27.256-30.928 39.819-24.378",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 510.597c-7.61-4.84-22.938 5.985-25.766 14.424-3.013 8.991 8.942 20.779 17.967 18.92 9.73-2.004 13.42-19.535 11.555-27.402-.695-2.932-2.027-4.842-3.756-5.942",
    style: {
      fill: "#ffd98b"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.236 563.502c2.783-16.821-12.569-3.51-20.48-6.198-5.738-1.95-10.752-11.63-15.317-15.808-6.688-6.121-14.224-11.233-22.599-14.753-16.206-6.811-40.447-9.243-57-3.77-18.901 6.25-41.461 19.146-49.135 38.578-13.041-7.863-19.412 1.825-22.06 13.834-5.134-4.632-12.165-13.914-17.258-3.644-5.114 10.31 5.826 21.31 13.181 26.975 30.22 23.275 67.777 32.289 100.22 34.275 31.351 1.919 79.609-12.535 99.024-42.754 5.284-8.227 8.85-33.568-8.576-26.735",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.941 597.764c-17.622-4.275-28.198-20.643-46.813-20.697-26.34-.077-32.339 16.049-51.492 20.697-11.828 2.87-30.646-.846-41.724 5.861 29.228 20.384 64.319 28.493 94.876 30.364 26.426 1.617 64.861-8.398 87.913-29.683-10.902-7.628-30.548-3.582-42.76-6.542",
    style: {
      fill: "#ffd98b"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.28 579.798c-2.933-9.321-25.921-10.776-26.633 1.58-.66 11.457 21.555 13.018 25.878 4.477 1.149-2.271 1.307-4.303.755-6.057",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.54 578.104c-1.745-1.631-5.03-2.963-6.88-2.053-4.532 2.232 2.185 6.208 5.196 5.841 3.607-.44 3.333-2.247 1.684-3.788",
    style: {
      fill: "#fff"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 269.583,
    cy: 572.464,
    r: 10.475,
    style: {
      fill: "#401f0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.319 570.853a4.318 4.318 0 1 1-8.637 0 4.318 4.318 0 0 1 8.637 0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 348.635,
    cy: 572.464,
    r: 10.475,
    style: {
      fill: "#401f0d"
    },
    transform: "rotate(-86.187 348.658 572.463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.371 570.853a4.318 4.318 0 1 1-8.637 0 4.319 4.319 0 0 1 8.637 0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.838 593.633c-.458 7.184-4.832 11.877-12.473 12.34-7.725.469-12.137-6.186-13.147-13.042-.494-3.359-5.582-1.926-5.092 1.404 1.428 9.699 8.732 17.495 18.979 16.875 10.315-.627 16.403-7.987 17.014-17.577.216-3.402-5.067-3.382-5.281 0",
    style: {
      fill: "#ff7900"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.388 698.978c-.483-4.977-3.13-16.866-11.895-13.806-9.746 3.41-13.257 33.918-11.558 40.787 2.497 10.091 16.335 9.082 20.58 0 1.529-3.269 3.897-16.435 2.873-26.981m72.202-3.254c-2.05-4.561-8.36-14.979-15.686-9.277-8.145 6.349-1.713 36.377 2.094 42.342 5.593 8.763 18.382 3.381 19.499-6.582.404-3.587-1.563-16.818-5.907-26.483",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-50.244 -122.545)scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZorro);
export default __webpack_public_path__ + "static/media/zorro.f3da46b55cfa6b3bc4413abb14fe0947.svg";
export { ForwardRef as ReactComponent };